<div class="container-fluid">
  <div class="row">

    @for(option of options; track $index) {

      <div class="col-12 mb-2">
        <div>
          <input 
            class="form-check-input me-2" 
            type="radio" 
            [name]="option.idPregunta" 
            [id]="option.idPregunta + '-' + option.idRespuesta"
            (change)="onSelect(option)"
            value="Test" 
            aria-label="...">
            <label 
              class="form-check-label" 
              [for]="option.idPregunta + '-' + option.idRespuesta">
              {{ option.respuesta }}
            </label>
        </div>
        
      </div>

    }

    @if(selected) {

      @if(selected.permiteTexto) {
        <div class="col-12 mt-3">
          <div>
            <input 
              type="text" 
              class="form-control" 
              placeholder="Especifique"
              [(ngModel)]="selected.respuestaTexto"
              [disabled]="!selected.permiteTexto"
              [maxlength]="answerMaxLength">
          </div>
        </div>
      }

      @for(pregunta of selected.preguntas; track $index) {

        <div class="col-12 mt-5">
          <div class="row">

            <app-pregunta-item
              [pregunta]="pregunta">
            </app-pregunta-item>

          </div>
        </div>

      }

    }

  </div>
</div>